import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanySalesOrderStatus } from './company-sales-order-status.type';
import { SalesOrderHeaderFormGroup } from './sales-order-header-form-group.interface';

export const SALES_ORDER_SHORT_DESCRIPTION_MAX_LENGTH = 512;

@Injectable()
export class SalesOrderHeaderFormModel {
  public readonly fieldNames = {
    clientId: 'clientId',
    status: 'status',
    requestedDeliveryDate: 'requestedDeliveryDate',
    shortDescription: 'shortDescription',
  } as const;

  public readonly form: FormGroup<SalesOrderHeaderFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<SalesOrderHeaderFormGroup>({
      clientId: new FormControl<string | null>(null),
      status: new FormControl<CompanySalesOrderStatus>('Draft', { nonNullable: true }),
      requestedDeliveryDate: new FormControl<string | null>(null),
      shortDescription: new FormControl<string | null>(null, {
        validators: [Validators.maxLength(SALES_ORDER_SHORT_DESCRIPTION_MAX_LENGTH)],
      }),
    });
  }
}
